import PageLayout from "@/components/PageLayout";
import PageHero from "@/components/PageHero";

const HERO_IMAGE = "/hero-magicprint.webp";

const TShirtBedrukkenZoetermeer = () => (
  <PageLayout
    title="T-shirts bedrukken in Zoetermeer"
    metaDescription="T-shirt bedrukken in Zoetermeer. Magic Print biedt flockdruk, DTG, zeefdruk, transferdruk, sublimatiedruk en DTF. Snelle levering vanuit Den Haag."
    ogImage={HERO_IMAGE}
    hero={
      <PageHero image={HERO_IMAGE} alt="T-shirts bedrukken in Zoetermeer" title="T-shirts bedrukken in Zoetermeer" subtitle="Snelle levering vanuit onze drukkerij in Den Haag." />
    }
  >
    
    <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
      Bent u op zoek naar hoogwaardige T-shirt bedrukking in Zoetermeer? Magic Print staat voor u klaar! Bij Magic Print beschikken we over geavanceerde professionele apparatuur die ervoor zorgt dat uw T-shirts voldoen aan al uw verwachtingen. Onze drukkerij is gevestigd in Den Haag, waardoor we snel ter plaatse kunnen zijn in Zoetermeer.
    </p>

    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Onze veelzijdige aanpak</h2>
      <p className="text-muted-foreground">
        Of u nu op zoek bent naar nette bedrijfskleding of speciale bedrukkingen voor evenementen en diverse toepassingen, wij hebben de expertise en capaciteit om aan al uw behoeften te voldoen. Ongeacht de gewenste oplage, onze ruime drukkerij in Den Haag kan elke vraag aan.
      </p>
    </section>

    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Uw keuze van druktechnieken</h2>
      <div className="space-y-6">
        {[
          { title: "Flockdruk", desc: "Een verfijnde techniek waarbij de print met behulp van verwarming en hoge druk op het textiel wordt aangebracht. Het resultaat is een prachtige afwerking met voelbare textuur, al beschikbaar vanaf 1 stuk." },
          { title: "DTG Printing", desc: "Direct to Garment printing is een moderne druktechniek waarbij full-color ontwerpen met watergedragen inkten rechtstreeks op het T-shirt worden afgedrukt. Perfect voor afbeeldingen met veel details en nuances." },
          { title: "Zeefdruk", desc: "Een klassieke en kosteneffectieve optie, ideaal voor grotere oplages vanaf 20 stuks. Deze techniek biedt duurzame en hoogwaardige afdrukken." },
          { title: "Transferdruk en borduren", desc: "Transferdruk is ideaal voor gedetailleerde ontwerpen. Borduren is een tijdloze en stijlvolle optie om uw T-shirts te personaliseren." },
          { title: "Sublimatiedruk", desc: "De ideale keuze voor levendige en duurzame kleuren op polyester textiel. Kleuren die niet vervagen, barsten of afschilferen, zelfs na herhaald wassen." },
          { title: "DTF (Direct to Film)", desc: "Een innovatieve techniek waarbij ontwerpen op een dunne film worden afgedrukt en met warmte en druk op het kledingstuk worden aangebracht. Hoge resolutie, geschikt voor kleine en grote oplages." },
        ].map((tech) => (
          <div key={tech.title} className="p-5 rounded-xl bg-card border border-border">
            <h3 className="text-lg font-semibold mb-2 text-[#0a2933]">{tech.title}</h3>
            <p className="text-sm text-muted-foreground">{tech.desc}</p>
          </div>
        ))}
      </div>
    </section>

    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Waarom kiezen voor Magic Print?</h2>
      <ul className="space-y-2 text-muted-foreground">
        <li>• <strong>Vakmanschap</strong> – Ons ervaren team streeft naar perfectie bij elke bedrukking.</li>
        <li>• <strong>Snelheid</strong> – Dankzij onze locatie in Den Haag kunnen we snel leveren in Zoetermeer.</li>
        <li>• <strong>Maatwerk</strong> – Verschillende druktechnieken en materialen om aan uw specifieke eisen te voldoen.</li>
        <li>• <strong>Duurzaamheid</strong> – Milieuvriendelijke druktechnieken en inkten.</li>
        <li>• <strong>Klantgerichtheid</strong> – Uw wensen en behoeften staan centraal.</li>
        <li>• <strong>Betaalbaarheid</strong> – Concurrerende prijzen voor kwaliteitsdrukwerk.</li>
      </ul>
    </section>
  </PageLayout>
);

export default TShirtBedrukkenZoetermeer;
